module.exports = __webpack_public_path__ + "static/45-dbaba20a60e8d389e4070ca5e5510201.png";